import React, { Component } from 'react';
import './ReportsPage.css';
import Page from '../../components/page/Page';
import Button from '../../components/button/Button';
import Card from '../../components/card/Card';
import Input from '../../inputs/input/Input';
import ReportContent from '../../components/reportContent/ReportContent';
import Label from '../../components/label/Label';

export default class ReportsPage extends Component {
	render() {
		return (
			<Page className="g-reports-page">
				<Card>
					<div className="top-row">
						<Input type="date"  />
						<Label className="date-separator">to</Label>
						<Input type="date" />
						<Button bg="blue" color="white">
							EXPORT (coming soon)
						</Button>
					</div>
					<ReportContent reportType="inventory" />
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/reportsPage/ReportsPage.jsx